import { Container as UnstatedContainer } from 'unstated';
import myGlobals from '../Utils/globals';
import { store as reduxStore } from "../redux/store";
import {changeStyleAction} from '../redux/actions/styleNameAction';
import { myUtilities } from '../Utils';
class LanguageDataContainer extends UnstatedContainer{
  constructor(props){
    super(props);
    this.state = {
        language: 'en',
        dropDownValues: [
            {
                name: 'English',
                value: 'en'
            }
        ],
        loading: true,
        disableAPICalls: false,
      styleName: "default",
      shouldStartStyleCall: false,
      linkInactive: false,
      messages: {},
      langCodeVsPmtCodeMap : new Map()
    };
    this.appUrlCall().then(() => {
       if (!this.state.disableAPICalls && this.state.shouldStartStyleCall)
        this.getUpdateStyleForGuestPay(this);
    });
}

    languageConfigsResponseHandler = (data) => {
        let dropDownValues = this.state.dropDownValues;
        
        let language = data.rows.defaultLanguageCode
    		? this.resolveLanguageCode(data.rows.defaultLanguageCode)
    		: this.state.language;
    		
        if(data.rows.dropDownValues!==undefined){
            if(data.rows.dropDownValues.length>0)
                dropDownValues = data.rows.dropDownValues;
        }
        
        let langKeys = dropDownValues.map((item) => item.value);
        language =
          myGlobals.langCodeDLP === "NA" ||
          !langKeys.includes(myGlobals.langCodeDLP)
            ? language
            : myGlobals.langCodeDLP;

            let pmtLangCode = data.rows.defaultReferenceCode;

        this.getLanguageJson(language);
        myGlobals.languageCode = language;
        myGlobals.pmtLanguageCode = pmtLangCode;
      let langCodeVsPmtCodeMap = new Map();
      dropDownValues.map( item => langCodeVsPmtCodeMap.set(item.value, item.reference));
    
        this.setState({
            language: language,
            dropDownValues: dropDownValues,
            loading: false, 
            langCodeVsPmtCodeMap
        });
    }
    
    fetchErrorHandler = () => {
        this.setState({
            loading: false
        });
    }

    populateLanguageConfigs = (onSuccess, onFetchError) => {
        const searchParams = new URLSearchParams();
        searchParams.append('token',myGlobals.token);
        let link = 'getLanguagesForGuestFlow';
        link = myGlobals.initialHost+myGlobals.appender+link;
                fetch(link, {
        //https://api.jsonbin.io/b/5e8cdf3f980e481b8aa07e9a/1
        //'https://api.myjson.com/bins/pgumg'

        method: 'POST',
        body: searchParams

        }).then(
        function(response){
            if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
                response.status);
            return;
            }
            //console.log(response.text());
            return response.json();
        }
        ).then(function(data){
        onSuccess(data);
        }).catch(
        function(err)
        {
            console.log('Fetch Error :-S',err);
            onFetchError();
        }
        );
    }

    populateDefaultLanguage = async () => {
        let timed = setInterval(() => {
           if(myGlobals.defaultLanguage!==null){
                this.setLanguage(myGlobals.defaultLanguage);
                stopTimed();
           } 
        }, 1000);
        let stopTimed = () => {
            clearInterval(timed);
        }
    }

    
    // redirection code for gold-platinum changes
    appUrlCall = async () => {
        const self = this;
        const searchParams = new URLSearchParams();
        searchParams.append('token',myGlobals.token);
        let url = 'getAppUrl';
        url = myGlobals.initialHost+myGlobals.appender+url;
                //url = 'https://gist.githubusercontent.com/mukundmadhav/3c2b08427a59bc3051ba0026e4080412/raw/3ddcc1cca6512296973168dfd146d2368dfe2cf0/gistfile1.txt'
        await fetch(url, {
          //https://gist.githubusercontent.com/gokuafrica/5b0d37cdbb37f0d47330131ea7d34d53/raw/77be266f60960b39b8b3f53de2e308fe11fe896a/test2
          method: 'POST',
          body: searchParams
    
        }).then(
          function(response){
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' +
                response.status);
                throw new Error('Status: '+response.status);
            }
            return response.text();
          }
        ).then(function(data){
          console.log(data);
          let count = 0;
          let index = -1;
          if(null != data && data != undefined){
            data = data.trim();
        }else{
             throw new Error('data null or undefined: '+data);
        }
        if(data === "inactive") {
          self.setState({shouldStartStyleCall: true, linkInactive: true});
          return;
        }

        let jsonData = JSON.parse(data).rows;

        if (jsonData === undefined) {
          self.terminateLink(JSON.parse(data), self);
          return;
        }

        let DLP_URL = jsonData.DLP_URL;
        let APP_URL = jsonData.APP_URL;

          for(let i=0;i<APP_URL.length;++i){
            if(APP_URL.substring(i,i+1).localeCompare("/")===0)
                count++;
            if(count==3){
              index = i;
              break;
            }
          }
          if(index>-1){
            let resolvedHost = APP_URL.substring(0,index);
            console.log(resolvedHost);
            let currentHost = window.location.origin;
            console.log(currentHost);
            if( currentHost.localeCompare(resolvedHost)!==0){
               self.setState({disableAPICalls: true});
               window.location.href = APP_URL+"payThroughEmail/?token="+myGlobals.token;
            } else {
            //get css name
              const reUrl = eval(myGlobals.reDirectParamInURL);
              if(DLP_URL != null && DLP_URL != undefined 
                  && DLP_URL != "" && reUrl) {
                self.setState({disableAPICalls: true});
                window.location.href = DLP_URL + "&gpToken=" + encodeURIComponent(myGlobals.token);
              } else {
                self.setState({shouldStartStyleCall: true});
              }
            	
          	}
          }
        }).catch(
          function(err)
          {
            console.log('Fetch Error :-S',err);
          }
        );
    }

  terminateLink = (data, self) => {
    myGlobals.failureReason = data.results;
    myGlobals.globalAccountId = data.globalAccountId;
    console.log("printing failure reason");
    console.log(myGlobals.failureReason);

    if (myGlobals.failureReason == "LINK_EXPIRED")
      myGlobals.errorMessage = myUtilities.accountSpecificLanguage(
        "Error.LinkExpired",
        "Link has expired"
      );
    else if (myGlobals.failureReason == "GUEST_PAY_NOT_ENABLED")
      myGlobals.errorMessage = myUtilities.accountSpecificLanguage(
        "Error.GuestPayNotEnabled",
        "Guest pay not enabled"
      );
    else
      myGlobals.errorMessage = myUtilities.accountSpecificLanguage(
        "Error.InvalidToken",
        "Invalid token"
      );
    myGlobals.linkTerminatedReason = myGlobals.errorMessage;
    self.setState({ shouldStartStyleCall: true, linkInactive: true });
  };
    
	getUpdateStyleForGuestPay = async (self) => {
	    
	    const searchParams = new URLSearchParams();
	    searchParams.append("token", myGlobals.token);
	    let link = "getStyleForGuestPay";
	    link = myGlobals.initialHost + myGlobals.appender + link;
      	    // link = "https://api.jsonbin.io/b/5fce1ea365c249127ba451c4";
	    fetch(link, {
	    //   method: "GET",
	    //   headers: {
	    //     "secret-key":
	    //       "$2b$10$V7Yj/PzFJS.MX80bYHIji.ocR9meNY9i6gHR6YjKjZkl9Qn8wGA9a",
	    //   },
	
	    method: 'POST',
	    body: searchParams
	    })
	      .then(function (response) {
	        if (response.status !== 200) {
	          console.log(
	            "Looks like there was a problem. Status Code: " + response.status
	          );
	          throw new Error('Status: '+response.status);
	        }
	        return response.json();
	      })
	      .then(function (data) {
	        console.log("getStyleForGuestPay", data);
	        if (data && data.rows) {
	          reduxStore.dispatch(
	            changeStyleAction({
	              CC_DI_CSS: data.rows.CC_DI_CSS !== undefined ? data.rows.CC_DI_CSS : reduxStore.getState().styleNames.CC_DI_CSS,
	              CC_DI_JS: data.rows.CC_DI_JS !== undefined ? data.rows.CC_DI_JS : reduxStore.getState().styleNames.CC_DI_JS,
	              RONE_CSS: data.rows.RONE_CSS !== undefined ? data.rows.RONE_CSS : reduxStore.getState().styleNames.RONE_CSS,
	          	}));
              
	          // call language api post style calls
		      self.populateLanguageConfigs(
		          self.languageConfigsResponseHandler,
		          self.fetchErrorHandler
		        );
	        }
	      })
	      .catch(function (err) {
	        self.populateLanguageConfigs(
		          self.languageConfigsResponseHandler,
		          self.fetchErrorHandler
		     );
	        console.log("Fetch Error :-S", err);
	      });
  	};
    
    resolveLanguageCode = (language) => language;

    setLanguage = async (language) => {
            myGlobals.languageCode=language;
            myGlobals.pmtLanguageCode = this.state.langCodeVsPmtCodeMap.get(myGlobals.languageCode);
            await this.setState({
                language: language
            });
    }

    setInitialLanguage = async (language) => {
        const setLanguage = this.setLanguage;
        setLanguage(language);
    }

    getLanguage = () => {
        return this.state.language;
    }
    getMessages = () => {
      return this.state.messages;
  	}
  	setMessages = async (language) => {
      myGlobals.messages = language;
      this.setState({
        messages: language
      });
    };
     getLanguageName = () => {
      let name = this.state.dropDownValues?.filter( langs => langs.value == this.state.language );
      name = name?.length > 0 ? name[0]?.name : "English";
      return name;
  	}
  	getLanguageJson = async (langCode) => {
      let self = this;
      let link = `${myGlobals.initialHost}${myGlobals.appender}i18nGP/i18nGP_${langCode}.json`;
              await fetch(link, {
          method: 'GET'
        }).then(resp => resp.json()).then(data=>{
          myGlobals.messages = data;
          self.setMessages(data);
        });
    }
}

export default LanguageDataContainer;
